import { LoadingState } from '../../types/loading-state';
import { isFetchedData } from '../../utils/fetched-data/is-fetched-data';
import { isFetchedDataValid } from '../../utils/fetched-data/is-fetched-data-valid';
export function cleanUpCachedFetchedData(cachedData, defaultState) {
    if (!cachedData)
        return cachedData;
    if (isFetchedData(cachedData)) {
        return isCachedDataValid(cachedData) ? cachedData : defaultState;
    }
    if (typeof cachedData === 'object') {
        Object.entries(cachedData).forEach(([key, childData]) => {
            cachedData[key] = cleanUpCachedFetchedData(childData, defaultState === null || defaultState === void 0 ? void 0 : defaultState[key]);
        });
    }
    return cachedData;
}
const isCachedDataValid = (cachedData) => cachedData.loadingState === LoadingState.NotLoaded || isFetchedDataValid(cachedData);
